import { LINKS } from '@utils/constants';
import cx from 'classnames';
import React from 'react';

import * as styles from './Modal.module.css';

import Columns from '@components/Layout/Columns/Columns';
import Button from '@components/Molecule/Button/Button';
import Cross from '@components/SVG/Cross';
import Logo from '@components/SVG/Logo';
import ProductSearch from '@components/Search/ProductSearch';

const Modal = ({
	showModal,
	setShowModal,
	children,
	as: Component = 'div',
	className = '',
}: {
	showModal: boolean;
	setShowModal: (value: boolean | ((prevVar: boolean) => boolean)) => void;
	children: React.ReactNode;
	as?: React.ElementType;
	className?: string;
}): JSX.Element => {
	const handleOnClick = () => {
		if (location.pathname === LINKS.PRODUCTS) setShowModal(!showModal);
	};

	return (
		<Component
			className={cx(styles.modal, {
				[styles.active]: showModal,
				[className]: !!className,
			})}>
			<div className="container container--grow">
				<div className={styles.heading}>
					<button
						onClick={() => setShowModal(false)}
						aria-label="UHV Design logo">
						<Logo className={styles.logo} />
					</button>

					<button
						className={styles.close}
						onClick={() => setShowModal(false)}>
						Close
						<Cross className={styles.cross} />
					</button>
				</div>
				<div className={styles.search}>
					<Columns gap="lg">
						<ProductSearch type="alternate" theme="dark" />

						<Button
							to={LINKS.PRODUCTS}
							theme="ghost"
							onClick={() => handleOnClick()}
							className={styles.button}>
							Show all product categories
						</Button>
					</Columns>
				</div>

				{children}
			</div>
		</Component>
	);
};

export default Modal;
